<div class="topdiv">
  
  <div class="testbed" >

    <div class="row" style="margin-top: -1%;">
    
    <div *ngIf="selectedGrid === 'new'" class="col-lg-12">
      <div >

        <mat-toolbar class="agGridtoperDiv card"
         style="
          background: rgb(228 227 230 / 41%);
          border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;
          border-left: 1px solid #a9a9a9a8;
        ">
          

          <label i18n="@@spmsUserReg" class="textColour">View Result</label>
          <span class="example-spacer"></span>

          <button
          class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Download"
          (click)="onBtExport()"
          style="font-size: 12px; padding: 4px 10px; height: 32px"
        >
          Download
          <em
            class="fas fa-download example-icon"
            style="font-size: 12px; padding: 0 5px"
          ></em>
        </button>

          <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Targetpageno">Page No</mat-label>
              <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
            </mat-form-field>
          </div>

          <div class="selectRecordsDiv" style="width:9.5%">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
              <mat-select  [(ngModel)]="RunpageSize1"  (ngModelChange)="onRunPageSizeChanged(value)">
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst1()"></em>
          </div>

          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon">
                <em class="fas fa-angle-left waves-effect waves-light" (click)="onRunBtPrevious1()"></em>
              </li>
              <li>{{RuncurrentPage1}}/{{RuntotalPages1}}</li>
              <li class="paginationliicon" style="padding:0;">
                <em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext1()"></em>
              </li>
            </ul>
          </div>

          <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast1()"></em>
          </div>
        </mat-toolbar>
      </div>

      <ag-grid-angular 
        class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        style="height: 55vh; width: 100%;"
        [columnDefs]="columnDefsExtractTemp"
        [animateRows]="true"
        [pagination]="true"
        [suppressPaginationPanel]="true"
        [rowHeight]="35"
        [headerHeight]="35"
        [defaultColDef]="defaultColDef"
        [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize"
        [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true"
        [debug]="true"
        (paginationChanged)="onloadPaginationChanged1()"
        [components]="components"
        (gridReady)="cellClickedObjects($event)"
        [hidden]="!true" >
      </ag-grid-angular>
    </div>
    </div>
    

    <!-- Buttons -->
  </div>
  <div style="height: 5vh; padding: 20px;margin-bottom: 3%;">

      <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%; background-color: white;">
        <div class="col-lg text-center">
          <div style="text-align: end;">

            <button type="button" (click)="cancel()"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="padding: .3rem 1.6rem; font-size: .85rem; width: 120px; color: white;">Close</button>
          </div>
        </div>
      </div>
    </div>

</div>
